module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agreement-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-q12 col-md-11"
  }, [_c('span', {
    staticClass: "agreement-item-highlight"
  }, [_vm._v("\n        " + _vm._s(_vm.agreement.title) + "\n      ")]), _vm._v("\n      číslo " + _vm._s(_vm.agreement.reference) + "\n      ze dne " + _vm._s(_vm.human_readable_date(_vm.agreement.created_at)) + "\n      "), _c('span', [_c('a', {
    attrs: {
      "href": '/api/agreements/' + _vm.agreement.id
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Stáhnout (PDF)\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-1 agreement-item-highlight"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-6"
  }, [_c('div', {
    staticClass: "document-preview"
  }, [_c('iframe', {
    key: _vm.iframeUpdateTrigger,
    staticStyle: {
      "border": "1px solid #ddd",
      "border-radius": "8px"
    },
    attrs: {
      "src": '/api/agreements/' + _vm.agreement.id + '?inline',
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "allow": "autoplay"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-md-5"
  }, [(_vm.agreement.cancelled_at) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        ❌ zrušená\n      ")]) : _c('div', [(_vm.agreement.signed_at) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          ✅ platná a podepsaná\n        ")]) : _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          ⏳ čeká na podpis\n        ")])]), _vm._v(" "), _vm._l((_vm.agreement.signatures), function(signature) {
    return _c('section', {
      staticClass: "alert alert-secondary",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n        Podpis " + _vm._s(signature.sequence + 1) + ": " + _vm._s(signature.caption) + "\n        "), (signature.signed_timestamp) ? _c('div', [_vm._v("\n          ✅ "), _c('span', {
      staticStyle: {
        "font-family": "cursive"
      }
    }, [_vm._v(_vm._s(signature.signed_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n            " + _vm._s(_vm.human_readable_date_time(signature.signed_timestamp)) + "\n          ")])]) : _c('div', [_vm._v("\n          ⏳ ještě nepodepsáno\n          "), (signature.allow_customer == 1) ? _c('div', [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "id": "btn-podepsatdokument"
      },
      on: {
        "click": function($event) {
          _vm.podepsatDokument(signature.sequence, signature.caption)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" PODEPSAT DOKUMENT\n            ")])]) : _vm._e()])])
  })], 2)]), _vm._v(" "), (_vm.displayError) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.displayError) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.showVerifyPhoneNumber) ? _c('div', [_c('verifyPhoneNumber', {
    attrs: {
      "index": _vm.defaultSmluvniNumberIdx
    },
    on: {
      "finished": function($event) {
        _vm.finishedPhoneNumberVerification()
      },
      "verified": function($event) {
        _vm.successfulPhoneNumberVerification()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.podpisovyModalShown) ? _c('agreementSign', {
    attrs: {
      "podpisProps": _vm.podpisovyModalProps
    },
    on: {
      "modal-hidden": function($event) {
        _vm.podpisovyModalShown = undefined
      },
      "document-sign-finished": function($event) {
        _vm.iframeUpdateTrigger = !_vm.iframeUpdateTrigger;
        _vm.$emit('reload-all-agreements')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-1 agreement-item-highlight"
  }, [_c('img', {
    attrs: {
      "src": "/static/free-icons/contract-icon-19930.png",
      "width": "60px",
      "height": "60px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b981fb6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Agreement.vue
// module id = 315
// module chunks = 1 2